(() => {
  'use strict';
  const normal = value => String(value).trim().toUpperCase().replace(/\s+/g, ' ');
  function alpha(value) {
    const v = normal(value);
    if (v === 'S') return 0;
    if (v === 'M') return 1;
    if (v === 'L') return 2;
    let m = v.match(/^(\d+)X(S|L)$/);
    if (m) return m[2] === 'S' ? -Number(m[1]) : 2 + Number(m[1]);
    m = v.match(/^(X+)(S|L)$/);
    if (m) return m[2] === 'S' ? -m[1].length : 2 + m[1].length;
    const parts = v.split('/');
    if (parts.length === 2) {
      const a = alpha(parts[0]), b = alpha(parts[1]);
      if (Number.isFinite(a) && Number.isFinite(b)) return (a + b) / 2;
    }
    return NaN;
  }
  function key(value) {
    const v = normal(value).replace(',', '.');
    const a = alpha(v);
    if (Number.isFinite(a)) return [1, a];
    const m = v.match(/^(?:EU\s*)?(\d+(?:\.\d+)?)(?:\s+(1\/2|1\/3|2\/3))?$/);
    if (m) return [0, Number(m[1]) + (m[2] ? Number(m[2][0]) / Number(m[2][2]) : 0)];
    const ages = ['BABY', 'BOY', 'JUNIOR', 'ADULT', 'SENIOR'];
    if (ages.includes(v)) return [2, ages.indexOf(v)];
    if (/^(TAGLIA )?(UNICA|UNICO|ONE SIZE|OS|OSFA)$/.test(v)) return [4, 0];
    return [3, 0];
  }
  function compare(a, b) {
    const x = key(a), y = key(b);
    return x[0] - y[0] || x[1] - y[1] || normal(a).localeCompare(normal(b), 'it', { numeric: true });
  }
  function reorder(box, selector, value) {
    const nodes = Array.from(box.querySelectorAll(selector)).filter(n => n.parentElement === box);
    const ordered = nodes.slice().sort((a, b) => compare(value(a), value(b)));
    if (ordered.some((n, i) => n !== nodes[i])) ordered.forEach(n => box.appendChild(n));
  }
  function prepare(root = document) {
    root.querySelectorAll('[data-option-kind="size"]').forEach(box => reorder(box, '.size-btn', n => n.dataset.value));
    root.querySelectorAll('.psi-chip-filter-title,.filter-group-toggle').forEach(title => {
      if (!/taglia|misura|size|numero/i.test(title.dataset.caption || title.textContent)) return;
      const group = title.parentElement;
      const box = group.querySelector('.psi-chip-filter-options,ul.filter-options,.filter-options,ul');
      if (box) reorder(box, ':scope > *', n => n.querySelector('input')?.value || n.querySelector('span')?.textContent || n.textContent);
    });
  }
  globalThis.PsiSizes = { compare, prepare };
  if (typeof document === 'undefined') return;
  let pending = false;
  const schedule = () => {
    if (pending) return;
    pending = true;
    queueMicrotask(() => { pending = false; prepare(); });
  };
  document.addEventListener('DOMContentLoaded', schedule);
  document.addEventListener('psi:catalog-updated', schedule);
  const relevant = '[data-option-kind="size"],.psi-chip-filter-title,.filter-group-toggle';
  new MutationObserver(records => {
    if (records.some(r => Array.from(r.addedNodes).some(n => n.nodeType === 1 && (n.matches(relevant) || n.querySelector(relevant))))) schedule();
  }).observe(document.body, { childList: true, subtree: true });
  prepare();
})();
